// import Header from "../Modules/header/header";
import { Link } from "react-router-dom";
import logo from "src/Assets/images/LandingPageImages/skopic-image.png";
import settingsStyles from "src/Assets/css/settings/settings.module.css";

const ModeratorGuidelines = () => {
  function ModeratorGuidelinesContent() {
    return (
      <div className={settingsStyles.headerContainer}>
        <div className={settingsStyles.headerContainer}>
          <div>
            <img src={logo} alt="Skopic-Logo" width={90} height={48} />
          </div>
        </div>
        <div className="innercontainer">
          <h3 className={settingsStyles.privacyheading}>
            Moderator Guidelines
          </h3>
          <div className={settingsStyles.TermsofService}>
          <p>
            <b>1. The Role of a Community Moderator</b>
          </p>
          <p>
            Community moderators play an important role in maintaining an
            informed, engaged, and well-organized community.
          </p>
          <p>
            In addition to understanding Skopic's Privacy Policy, Terms of Use,
            and User Guidelines, moderators should follow these principles to
            lead and manage their communities effectively.
          </p>
          <br />

          <p>
            <b>2. Responsibilities of a Successful Moderator</b>
          </p>

          <p>
            <b>Be an Active Community Member</b>
          </p>
          <p>
            Be a responsible, engaged, and passionate member of the community you
            moderate. Lead by example through meaningful contributions and
            constructive participation.
          </p>
          <br />

          <p>
            <b>Stay Informed</b>
          </p>
          <p>
            Continuously research the topics relevant to your community through
            the internet, social media, and traditional media. Staying informed
            helps you organize content and moderate discussions effectively.
          </p>
          <br />

          <p>
            <b>Organize Community Content</b>
          </p>
          <p>
            Classify, categorize, and organize information appropriately. Use
            ASK, SAY, TAG, and UPDATE features to make community knowledge easier
            to discover.
          </p>
          <br />

          <p>
            <b>Keep the Community Active</b>
          </p>
          <p>
            Encourage positive participation by keeping community content
            current, relevant, and useful to members.
          </p>
          <br />

          <p>
            <b>Review Flagged Content</b>
          </p>
          <p>
            Review posts flagged as abusive or inappropriate and remove them
            promptly or periodically, at your discretion, in accordance with
            Skopic's guidelines.
          </p>
          <br />

          <p>
            <b>Manage Invitations</b>
          </p>
          <p>
            For invite-only communities, review membership invitations and
            approve or reject requests in a timely manner.
          </p>
          <br />

          <p>
            <b>Appoint Additional Moderators</b>
          </p>
          <p>
            Identify responsible, engaged members who can help moderate the
            community and maintain its quality.
          </p>
          <br />

          <p>
            <b>Establish Appropriate Posting Rules</b>
          </p>
          <p>
            Periodically review your community's posting rules and decide whether
            content should require pre-approval before publication.
          </p>
          <p>
            Since Skopic is a community-sourced information network, the balance
            between open participation and pre-approval moderation plays an
            important role in determining how the community grows and shares
            knowledge.
          </p>
          <br />

          <p>
            <b>3. Recommended Practices for Driving Engagement</b>
          </p>
          <p>
            The following practices can help build an active, informed, and
            engaged community.
          </p>
          <br />

          <p>
            <b>1. Add Questions and Answers Regularly</b>
          </p>
          <p>
            Post relevant questions (ASKs) and contribute answers through SAYs.
            Aim to do this at least 3–4 times per week.
          </p>
          <br />

          <p>
            <b>2. Build Knowledge Around TAGs</b>
          </p>
          <p>
            Create TAGs for important issues, topics, activities, or subgroups.
            Contribute approximately 10–15 relevant posts per TAG over a period
            of 3–5 days to develop a useful body of information.
          </p>
          <br />

          <p>
            <b>3. Introduce New TAGs Periodically</b>
          </p>
          <p>
            Create a new TAG in each community every 5–7 days, where appropriate,
            to organize information around emerging topics, activities, and
            areas of interest.
          </p>
          <br />

          <p>
            <b>4. Publish Regular Community UPDATES</b>
          </p>
          <p>
            Publish one Community UPDATE each day, when there is relevant
            information to share. Include reminders when an UPDATE involves an
            upcoming event, deadline, or important activity.
          </p>
          <br />

          <p>
            <b>5. Encourage Regular SAY Contributions</b>
          </p>
          <p>
            Share knowledge, observations, and useful information through SAY
            posts on a regular basis.
          </p>
          <p>
            Consistent contributions are essential to building a comprehensive
            community knowledge base that helps members find answers to important
            questions.
          </p>
          <br />

          <p>
            <b>6. Use UPDATES and TAGs Thoughtfully</b>
          </p>
          <p>
            Remember that creating a Community UPDATE or a new #TAG triggers
            notifications to community members.
          </p>
          <p>
            Use these features strategically to highlight important information,
            encourage participation, and keep members informed. Relevant and
            timely notifications can help strengthen engagement and maintain an
            active community.
          </p>
          <br />

          <p>
            <b>Thank You</b>
          </p>
          <p>
            Thank you for being part of Skopic and helping build a more informed,
            connected, and engaged community.
          </p>
          <p>
            Your contributions make your community's knowledge network stronger.
          </p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      {/* <Header /> */}
      {<ModeratorGuidelinesContent />}
    </div>
  );
};
export default ModeratorGuidelines;
